var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowBoldRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.325 1.153c-0.294 0.279-0.476 0.672-0.476 1.107 0 0.415 0.166 0.791 0.434 1.066l0.042 0.042 3.365 3.067-4.11-0.021-5.004-0.064c-0.009 0-0.020-0-0.030-0-0.842 0-1.527 0.673-1.546 1.511v0.066c0.015 0.888 0.731 1.603 1.617 1.619h0.002s8.965 0.107 9.072 0.085l-3.365 3.003c-0.294 0.279-0.476 0.672-0.476 1.107 0 0.415 0.166 0.791 0.434 1.066l0.042 0.042c0.294 0.287 0.696 0.463 1.139 0.463s0.846-0.177 1.14-0.464l-0.001 0.001 5.92-5.75c0.294-0.279 0.476-0.672 0.476-1.107 0-0.415-0.166-0.791-0.434-1.066l-0.042-0.042-5.92-5.729c-0.294-0.287-0.696-0.463-1.139-0.463s-0.846 0.177-1.14 0.464l0-0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBoldRight);
export default __webpack_public_path__ + "static/media/arrow-bold-right.7bb38681.svg";
export { ForwardRef as ReactComponent };